import { usePathname } from 'expo-router'

import { Tab } from '@/src/elements/navigation/tab'

export default function NavTabLayout() {
  const pathname = usePathname()
  const activePage = pathname.split('/')[1]

  return <Tab activePage={activePage} />
}
